<template>
  <v-container fluid>
    <v-flex xs12 v-if="statusDisplayNames.length">
      <email-select
        v-for="status in statusDisplayNames"
        :displayName="status.displayName"
        :registrationStatus="status.registrationStatus"
        :key="status.registrationStatus"
      />
    </v-flex>
  </v-container>
</template>

<script>
  import EmailSelect from './emailSelect'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'AttendeeRegistrationRemind',
    components: {
      EmailSelect
    },
    data () {
      return {}
    },
    computed: {
      ...mapGetters([
        'statusDisplayNames'
      ])
    },
    methods: {
      ...mapActions([
        'getStatusDisplayNames',
        'getAttendeeReminders'
      ]),
      async getData () {
        await this.getAttendeeReminders()
        await this.getStatusDisplayNames()
      }
    },
    created () {
      this.getData()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/AttendeeRegistrationRemind/index.vue